import { observer } from 'mobx-react-lite';
import React from 'react';
import { AppProps } from './App';
import { toggleNavigationMenu } from '../stores/styleStore';
import { action, runInAction } from 'mobx';
import { generatePrettyPath } from '../lib/utils';
import { AppState, filterIxList } from '../stores/appStateStore';
import { PAGE_LENGTH } from './MessageListPage';

function isValidPageNumber(state: AppState, pageNum: number) {
    if(pageNum < 0) {
        return false;
    }
    const listLength = state.messageQueryAndIxList.filteredIxList.length;
    if(pageNum*PAGE_LENGTH > listLength - 1) {
        return false;
    }
    return true;
} // isValidPageNumber()

const Navbar = observer((props: AppProps) => {
    const {state, styles} = props;

    const searchQueryFile = state.mboxList[state.messageQueryAndIxList.fileIx];

    function ifKeyIsEnterThenSearch(e: React.KeyboardEvent) {
        if(e.key === 'Enter') {
            runInAction(() => {filterIxList(state);});
        }
    } // ifKeyIsEnterThenSearch()

    return (
        <div className="navbar">
            <button className={styles.get('navigation.nb-burger').classNames} onClick={e => toggleNavigationMenu(styles)}><i className="hamburger-icon"/></button>
            {state.cancellationFunctions.length > 0 && state.cancellationFunctions.length > state.cancellationOpenIndexes.length ?<div className='lds-ring'><div onClick={action(e => {
                while(state.cancellationFunctions.length > 0) {
                    const fn = state.cancellationFunctions.pop();
                    if(fn) {
                        fn();
                    }
                }
                while(state.cancellationOpenIndexes.length > 0) {
                    state.cancellationOpenIndexes.pop();
                }
            })} title="Cancel all file loads and filter updates."/><div/><div/><div/></div>:''}
            
            {state.currentView !== 'landing'? 
                <button className="navbarButton" onClick={action(e => {
                    state.currentView = 'landing';
                    })}><div className="big-and-bold" title="Return to upload page (not needed for drag and drop!)">X</div>
                </button>
            :''}
            {
                state.currentView === 'messageList' && searchQueryFile?
                <div className="flex-mother-col">
                    <div className="flex-1" />
                    <div>{generatePrettyPath(searchQueryFile.name + '/' + state.messageQueryAndIxList.label, searchQueryFile.labelMetadata?.labelCapitalization)}</div>
                    <div className="flex-1" />
                </div>:
                ''
            }
            <div className="flex-1 flex-mother">
                {state.currentView === 'messageList'?<>
                    <div className="flex-1" />
                    <div className="flex-mother-col">
                        <div className="flex-1" />
                        <div className="flex-1 flex-mother">
                            <input className="search-box" value={state.messageQueryAndIxList.grep} 
                                onChange={action((e) => {state.messageQueryAndIxList.grep = e.target.value;})} 
                                onKeyDown={ifKeyIsEnterThenSearch}
                                placeholder="Search Raw Text" />
                            <button className="search-button" onClick={action(() => {filterIxList(state);})}><i className="search-icon"/></button>
                        </div>
                        <div className="flex-1" />
                    </div>
                    <div className="flex-1" />
                </>:''}
            </div>
            {state.currentView === 'messageList'?<>
            <div className="flex-mother-col">
                <div className="flex-1" />
                {isValidPageNumber(state, state.sorting.page - 1)?
                    <button className="navbarButton-half" onClick={action(() => {
                        state.sorting.page--;
                    })}>
                        <i className="arrow-left-secondary"/>
                    </button>:
                    <button className="navbarButton-half-gray">
                        <i className="arrow-left-secondary"/>
                    </button>
                }
                <div className="flex-1" />  
            </div>
            <div className="flex-mother-col">
                <div className="flex-1" />
                <div className="pb-2px">{state.sorting.page*PAGE_LENGTH + 1} - {Math.min((state.sorting.page+1)*PAGE_LENGTH, state.messageQueryAndIxList.filteredIxList.length)}</div>
                <div className="flex-1" />  
            </div>
            <div className="flex-mother-col">
                <div className="flex-1" />
                {isValidPageNumber(state, state.sorting.page + 1)?
                    <button className="navbarButton-half" onClick={action(() => {
                        state.sorting.page++;
                    })}>
                        <i className="arrow-right-secondary"/>
                    </button>:
                    <button className="navbarButton-half-gray">
                        <i className="arrow-right-secondary"/>
                    </button>
                }
                <div className="flex-1" />  
            </div>
            </>:''}
            <button className="navbarButton" onClick={action(e => {
                const currentLightMode = styles.get('app-wide');
                if(currentLightMode.classNames === 'dark-mode') {
                    currentLightMode.classNames = 'light-mode';
                } else {
                    currentLightMode.classNames = 'dark-mode';
                }
            })}><i className="light-dark-icon"/></button>
        </div>
    );
});

export default Navbar;